module.exports = __webpack_public_path__ + "static/media/vector-art1.e0b29cee.jpg";